import Notify from './notify';

/**
 * Class to validate the inputs.
 */
export default class Validation {
	/**
	 * Validation constructor.
	 */
	constructor(params) {
		this.target = params && params.target ? params.target : document;
		this.allInputs = Array.from(this.target.getElementsByClassName('validate'));
	}

	/**
	 * Validate the given number.
	 *
	 * @param number
	 * @returns {boolean}
	 */
	validateNumber(number) {
		const re = /^$|^[0-9]\d*$/;
		return re.test(String(number).toLowerCase());
	}

	/**
	 * Validate the given number, data is required.
	 *
	 * @param number
	 * @returns {boolean}
	 */
	validateNumberRequired(number) {
		const re = /^[0-9]\d*$/;
		return re.test(String(number).toLowerCase());
	}

	/**
	 * Validate the given number.
	 *
	 * @param number
	 * @returns {boolean}
	 */
	validateIntAndFloat(number) {
		const re = /^$|^[0-9]*([,.][0-9]{1,2})?$/;
		return re.test(String(number).toLowerCase());
	}

	/**
	 * Validate the given number, data is required.
	 *
	 * @param number
	 * @returns {boolean}
	 */
	validateIntAndFloatRequired(number) {
		const re = /^[0-9]+([,.][0-9]{1,2})?$/;
		return re.test(String(number).toLowerCase());
	}

	/**
	 * Validate the given text.
	 *
	 * @param text
	 * @returns {boolean}
	 */
	validateText(text) {
		const re = /^$|.*?/;
		return re.test(String(text).toLowerCase());
	}

	/**
	 * Validate the given text, data is required.
	 *
	 * @param text
	 * @returns {boolean}
	 */
	validateTextRequired(text) {
		return !!text;
	}

	/**
	 * Validate the given phone.
	 *
	 * @param phone
	 * @returns {boolean}
	 */
	validatePhone(phone) {
		const re = /^$|^(?!\s*$).+/;
		return re.test(String(phone).toLowerCase());
	}

	/**
	 * Validate the given phone, data is required.
	 *
	 * @param phone
	 * @returns {boolean}
	 */
	validatePhoneRequired(phone) {
		const re = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/gm;
		return re.test(String(phone).toLowerCase());
	}

	/**
	 * Validate the given phone, data is required.
	 *
	 * @param phonenumber
	 * @returns {boolean}
	 */
	validatePhonenumber(phonenumber) {
		const re = /^[\d\s-+]+$/;
		return re.test(String(phonenumber).toLowerCase());
	}

	/**
	 * Validate the given url.
	 *
	 * @param url
	 * @returns {boolean}
	 */
	validateUrl(url) {
		const re = /^$|^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
		return re.test(String(url).toLowerCase());
	}

	/**
	 * Validate the given url, data is required.
	 *
	 * @param url
	 * @returns {boolean}
	 */
	validateUrlRequired(url) {
		const re = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
		return re.test(String(url).toLowerCase());
	}

	/**
	 * Validate the given name.
	 *
	 * @param name
	 * @returns {boolean}
	 */
	validateName(name) {
		const re = /^$|^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/;
		return re.test(String(name).toLowerCase());
	}

	/**
	 * Validate the given name, data is required.
	 *
	 * @param name
	 * @returns {boolean}
	 */
	validateNameRequired(name) {
		if (name.length === 0) {
			return false;
		}

		const re = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/;
		return re.test(String(name).toLowerCase());
	}

	/**
	 * Validate the given email.
	 *
	 * @param email
	 * @returns {boolean}
	 */
	validateEmail(email) {
		const re = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	/**
	 * Validate the given email, data is required.
	 *
	 * @param email
	 * @returns {boolean}
	 */
	validateEmailRequired(email) {
		let email2 = email.trim();
		console.log(email2);
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email2).toLowerCase());
	}

	/**
	 * Handle the main method for validation.
	 *
	 * @returns {boolean}
	 */
	handle() {
		const allInputs = this.allInputs;

		allInputs.map(item => {
			let validate;
			const formFieldChildren = Array.from(item.parentNode.parentNode.children);
			const errorMessageNode = formFieldChildren.length - 1;

			switch (item.dataset.type) {
				case 'text':
					validate = this.validateText;
					break;
				case 'text-required':
					validate = this.validateTextRequired;
					break;
				case 'letters':
					validate = this.validateName;
					break;
				case 'letters-required':
					validate = this.validateNameRequired;
					break;
				case 'email':
					validate = this.validateEmail;
					break;
				case 'email-required':
					validate = this.validateEmailRequired;
					break;
				case 'number':
					validate = this.validateNumber;
					break;
				case 'number-required':
					validate = this.validateNumberRequired;
					break;
				case 'int-float-number':
					validate = this.validateIntAndFloat;
					break;
				case 'int-float-number-required':
					validate = this.validateIntAndFloatRequired;
					break;
				case 'tel':
					validate = this.validatePhone;
					break;
				case 'tel-required':
					validate = this.validatePhoneRequired;
					break;
				case 'phonenumber':
					validate = this.validatePhonenumber;
					break;
				case 'url':
					validate = this.validateUrl;
					break;
				case 'url-required':
					validate = this.validateUrlRequired;
					break;
				default:
					validate = this.validateText;
			}

			if (validate(item.value)) {
				item.parentNode.classList.remove('--is-invalid');
//				formFieldChildren[errorMessageNode].style.display = 'none';
			} else if (item.offsetParent !== null && !validate(item.value)) {
				item.parentNode.classList.add('--is-invalid');
				formFieldChildren[errorMessageNode].style.display = 'inline-block';
			}

			let counter = 0;
			allInputs.map(item => {
				item.parentNode.classList.contains('--is-invalid') && counter++;
			});
			counter === 0 ? (this.hasError = false) : (this.hasError = true);
		});

		if (this.hasError) {
			const notify = new Notify();
			notify.error('The data is invalid');
		}
		return !this.hasError;
	}
}
